// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.XrkoUSBDt7ktdOke {
	display: grid;
	grid-template-columns: auto 1fr;
	grid-template-rows: auto auto;
	column-gap: var(--lok-spacing-2);
	border-radius: var(--lok-radius-l);
	padding: var(--lok-spacing-4);
	width: 500px;

	background-color: var(--lok-color-background-surface-middle);
}

.d28A7xCgP14YkDZ8 {
	display: flex;
	align-items: center;

	grid-column: 1;
	grid-row: 1;
}

.S73KXJHrf78XnNjj {
	grid-column: 2;
	grid-row: 1;

	color: var(--lok-color-text-default);
	font: var(--lok-typography-body-small-strong);
	font-family: var(--lok-font-family-inter);
}

.iJcpT9e_RIpJjv3n {
	grid-column: 2;
	grid-row: 2;

	color: var(--lok-color-text-light-default);
	font: var(--lok-typography-body-small-default);
	font-family: var(--lok-font-family-inter);
}
`, "",{"version":3,"sources":["webpack://./packages/rag/src/components/DescriptionWithIcon/DescriptionWithIcon.module.css"],"names":[],"mappings":"AAAA;CACC,aAAa;CACb,+BAA+B;CAC/B,6BAA6B;CAC7B,gCAAgC;CAChC,kCAAkC;CAClC,6BAA6B;CAC7B,YAAY;;CAEZ,4DAA4D;AAC7D;;AAEA;CACC,aAAa;CACb,mBAAmB;;CAEnB,cAAc;CACd,WAAW;AACZ;;AAEA;CACC,cAAc;CACd,WAAW;;CAEX,oCAAoC;CACpC,6CAA6C;CAC7C,yCAAyC;AAC1C;;AAEA;CACC,cAAc;CACd,WAAW;;CAEX,0CAA0C;CAC1C,8CAA8C;CAC9C,yCAAyC;AAC1C","sourcesContent":[".step {\n\tdisplay: grid;\n\tgrid-template-columns: auto 1fr;\n\tgrid-template-rows: auto auto;\n\tcolumn-gap: var(--lok-spacing-2);\n\tborder-radius: var(--lok-radius-l);\n\tpadding: var(--lok-spacing-4);\n\twidth: 500px;\n\n\tbackground-color: var(--lok-color-background-surface-middle);\n}\n\n.iconContainer {\n\tdisplay: flex;\n\talign-items: center;\n\n\tgrid-column: 1;\n\tgrid-row: 1;\n}\n\n.stepHeading {\n\tgrid-column: 2;\n\tgrid-row: 1;\n\n\tcolor: var(--lok-color-text-default);\n\tfont: var(--lok-typography-body-small-strong);\n\tfont-family: var(--lok-font-family-inter);\n}\n\n.stepText {\n\tgrid-column: 2;\n\tgrid-row: 2;\n\n\tcolor: var(--lok-color-text-light-default);\n\tfont: var(--lok-typography-body-small-default);\n\tfont-family: var(--lok-font-family-inter);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"step": `XrkoUSBDt7ktdOke`,
	"iconContainer": `d28A7xCgP14YkDZ8`,
	"stepHeading": `S73KXJHrf78XnNjj`,
	"stepText": `iJcpT9e_RIpJjv3n`
};
export default ___CSS_LOADER_EXPORT___;
